import {User} from "@core/model/user.model";

export class ScopeVoter {
  id?: number
  voter!: User
  submitted?: boolean
  submittedTs?: Date
}
